import React from 'react';
import {
  Box,
  Button,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { BasicIdCombo } from '../core/BasicIdCombo';
import { IAllocationCostCenter } from './budgetallocation.models';

type Props = {
  costcenters: IAllocationCostCenter[];
  selectedCostCenter: number | null;
  activitySearch: string;
  lineItemSearch: string;
  loading?: boolean;
  onCostCenterChange: (id: number | null) => void;
  onActivitySearchChange: (v: string) => void;
  onLineItemSearchChange: (v: string) => void;
  onRefresh: () => void;
};

class BudgetAllocationFilterBar extends React.Component<Props> {
  render() {
    const p = this.props;
    const active = !!p.selectedCostCenter;

    return (
      <Paper elevation={1} sx={{ p: 2, mb: 3 }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'stretch', md: 'center' }}
          spacing={2}
          sx={{ mb: 2 }}
        >
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              Activity Budget Filters
            </Typography>
            <Typography variant="caption" color="text.secondary">
              View the complete Activity Budget or select a Cost Centre to work with its allocations.
            </Typography>
          </Box>

          <Button
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={p.onRefresh}
            disabled={p.loading}
          >
            Refresh
          </Button>
        </Stack>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 3 }}>
            <BasicIdCombo
              label="Cost Centre"
              items={p.costcenters || []}
              value={p.selectedCostCenter}
              onChange={(v: any) =>
                p.onCostCenterChange(v === null || v === '' ? null : Number(v))
              }
              disabled={p.loading}
            />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <TextField
              size="small"
              label="Search Activity Plans"
              value={p.activitySearch || ''}
              onChange={(e) => p.onActivitySearchChange(e.target.value)}
              disabled={p.loading || !active}
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <TextField
              size="small"
              label="Search Budget Accounts"
              value={p.lineItemSearch || ''}
              onChange={(e) => p.onLineItemSearchChange(e.target.value)}
              disabled={p.loading || !active}
              fullWidth
            />
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

export default BudgetAllocationFilterBar;
